import {Attributes} from "@opentelemetry/api";

export abstract class TrackingTool<DataType = Attributes>
{
  abstract isAvailable(): boolean;
  abstract trackEvent(eventName: string, data: DataType): void;
}
